import getActiveContentTab from './getActiveContentTab';
import { TabType } from '../store/schema/TabViewState';
import type SecondaryReadingPaneTabData from '../store/schema/SecondaryReadingPaneTabData';
import type { MailboxInfo } from 'owa-client-types';

export default function getActiveSecondaryReadingPaneTabMailboxInfo(): MailboxInfo | undefined {
    const activeTab = getActiveContentTab();
    if (activeTab?.type === TabType.SecondaryReadingPane) {
        const tabData = activeTab.data as SecondaryReadingPaneTabData | undefined;
        return tabData?.id?.mailboxInfo;
    }
    return undefined;
}
